export default __webpack_public_path__ + "app/views/accounts/tabs/tab-overview.html";